import {
  VariantBranchSupplier,
  variantsApi,
} from '@texas/api/endpoints/variantsApi';
import { VerifyDialogWithRequest } from '@texas/components/shared/dialog/VerifyDialogWithRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { useTranslation } from 'react-i18next';

interface EnableSupplierDialogProps extends SharedDisclosureProps {
  supplier: VariantBranchSupplier;
  onEnable: () => void;
}

export function EnableSupplierDialog(props: EnableSupplierDialogProps) {
  const { t } = useTranslation();

  return (
    <VerifyDialogWithRequest
      headerTitle={t('variant.supplier.enable')}
      secondaryButtonTitle={t('general.cancel')}
      primaryButtonTitle={t('general.confirm')}
      primaryRequest={variantsApi.enableSupplierBranch}
      args={[props.supplier.id]}
      isOpen={props.isOpen}
      onClose={props.onClose}
      onPerformed={props.onEnable}
      onSuccessTitle={t('general.successfullyEnabled')}
    >
      {t('variant.supplier.enableInfo')}
    </VerifyDialogWithRequest>
  );
}
